import React from 'react';

export default function CardDetail() {
  return (
    <div className="border rounded bg-white">
      <div className="flex flex-col py-8 px-7 font-[Rubik]">
        <p className="text-lg text-primary font-medium mb-7">Detail Wisata</p>
        <p className="text-[#666666] text-sm">Jam Operasional</p>
        <p className="text-[#999999] text-base">Setiap Hari: 07.00 s/d 22.00 WIB</p>
        <p className="text-[#666666] text-sm mt-7">Harga Tiket Masuk</p>
        <p className="text-[#999999]">
          Dewasa: <span className="text-[#FFCC16]">Rp. 12.000,-</span>
        </p>
        <p className="text-[#999999]">
          Anak-anak: <span className="text-[#FFCC16]">Rp. 10.000,-</span>
        </p>
        <div>
          <p className="text-[#666666] text-sm mt-7">Kontak Kami</p>
          <ul className="text-[#999999] sm:text-sm text-xs my-3">
            <li className="flex items-center my-3">
              <img src="/assets/images/email.svg" alt="email" className="mr-5" />
              <a href="#">visittegal@gmail.com</a>
            </li>
            <li className="flex items-center my-3">
              <img src="/assets/images/phone.svg" alt="phone" className="mr-5" />
              <a href="#">0856-4044-0802</a>
            </li>
            <li className="flex items-center my-3">
              <img src="/assets/images/instagram.svg" alt="instagram" className="mr-5" />
              <a href="#">@visittegal</a>
            </li>
          </ul>
        </div>
      </div>
      <button className="bg-primary text-white text-base w-full py-4 rounded-t-none font-medium">
        Pesan Tiket
      </button>
    </div>
  );
}
